import React from "react";
import * as S from "./styles";

interface IRowLabelProps {
	label: string | React.ReactNode;
	content: string | React.ReactNode;
	propsLabel?: React.HTMLAttributes<HTMLParagraphElement>;
	propsContent?: React.HTMLAttributes<HTMLParagraphElement>;
	className?: string;
	isEllipsisText?: boolean;
}

function RowLabel({ label, content, propsLabel, propsContent, className, isEllipsisText = false }: IRowLabelProps) {
	const isString = (value: any) => typeof value === "string";

	return (
		<S.Container className={className} $isEllipsisText={isEllipsisText}>
			<S.LabelArea>
				{isString(label) ? <S.LabelText {...propsLabel}>{`${label}:`}</S.LabelText> : `${label}:`}
			</S.LabelArea>
			<S.ContentArea>
				{isString(content) ? (
					<S.ContentText {...propsContent} title={content}>
						{content}
					</S.ContentText>
				) : (
					content
				)}
			</S.ContentArea>
		</S.Container>
	);
}

export default RowLabel;
